import { apiClient } from './api';

export const problemApi = {
  // Get all problems with filtering
  getProblems: async (filters = {}) => {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.priority) params.priority = filters.priority;
    if (filters.limit) params.limit = filters.limit;
    
    const response = await apiClient.get('/problems', { params });
    return response.data;
  },

  // Get problem statistics
  getProblemStats: async () => {
    const response = await apiClient.get('/problems/stats');
    return response.data;
  },

  // Get problem by ID
  getProblem: async (problemId) => {
    const response = await apiClient.get(`/problems/${problemId}`);
    return response.data;
  },

  // Create a new problem
  createProblem: async (problem) => {
    const response = await apiClient.post('/problems', problem);
    return response.data;
  },

  // Update problem
  updateProblem: async (problemId, updates) => {
    const response = await apiClient.put(`/problems/${problemId}`, updates);
    return response.data;
  },

  // Create mock data for testing
  createMockProblems: async () => {
    const response = await apiClient.post('/mock-data/problems');
    return response.data;
  }
};

export const rcaApi = {
  // Get RCA agents
  getRCAAgents: async () => {
    const response = await apiClient.get('/rca-agents');
    return response.data;
  },

  // Get RCA agent details
  getRCAAgentDetails: async (agentId) => {
    const response = await apiClient.get(`/rca-agents/${agentId}`);
    return response.data;
  },

  // Create RCA agent
  createRCAAgent: async (agent) => {
    const response = await apiClient.post('/rca-agents', agent);
    return response.data;
  },

  // Update RCA agent
  updateRCAAgent: async (agentId, updates) => {
    const response = await apiClient.put(`/rca-agents/${agentId}`, updates);
    return response.data;
  },

  // Perform RCA analysis
  performRCAAnalysis: async (problemId, rcaAgentId) => {
    const response = await apiClient.post(`/problems/${problemId}/rca-analysis`, null, {
      params: { rca_agent_id: rcaAgentId }
    });
    return response.data;
  },

  // Auto-detect problems
  autoDetectProblems: async (agentId) => {
    const response = await apiClient.post(`/rca-agents/${agentId}/detect-problems`);
    return response.data;
  },

  // Create mock RCA agents
  createMockRCAAgents: async () => {
    const response = await apiClient.post('/mock-data/rca-agents');
    return response.data;
  }
};

// Constants for dropdowns and filtering
export const PROBLEM_PRIORITIES = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

export const PROBLEM_STATUSES = {
  NEW: 'NEW',
  ANALYSIS_IN_PROGRESS: 'ANALYSIS_IN_PROGRESS',
  ROOT_CAUSE_IDENTIFIED: 'ROOT_CAUSE_IDENTIFIED',
  SOLUTION_PROPOSED: 'SOLUTION_PROPOSED',
  SOLUTION_IMPLEMENTED: 'SOLUTION_IMPLEMENTED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED'
};

export const ROOT_CAUSE_CATEGORIES = {
  SYSTEM_DESIGN: 'SYSTEM_DESIGN',
  CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
  HUMAN_ERROR: 'HUMAN_ERROR',
  PROCESS_FAILURE: 'PROCESS_FAILURE',
  HARDWARE_FAILURE: 'HARDWARE_FAILURE',
  SOFTWARE_BUG: 'SOFTWARE_BUG',
  CAPACITY_ISSUE: 'CAPACITY_ISSUE',
  SECURITY_VULNERABILITY: 'SECURITY_VULNERABILITY',
  THIRD_PARTY_DEPENDENCY: 'THIRD_PARTY_DEPENDENCY',
  UNKNOWN: 'UNKNOWN'
};

export const STATUS_LABELS = {
  [PROBLEM_STATUSES.NEW]: 'New',
  [PROBLEM_STATUSES.ANALYSIS_IN_PROGRESS]: 'Analysis in Progress',
  [PROBLEM_STATUSES.ROOT_CAUSE_IDENTIFIED]: 'Root Cause Identified',
  [PROBLEM_STATUSES.SOLUTION_PROPOSED]: 'Solution Proposed',
  [PROBLEM_STATUSES.SOLUTION_IMPLEMENTED]: 'Solution Implemented',
  [PROBLEM_STATUSES.CLOSED]: 'Closed',
  [PROBLEM_STATUSES.CANCELLED]: 'Cancelled'
};

export const ROOT_CAUSE_LABELS = {
  [ROOT_CAUSE_CATEGORIES.SYSTEM_DESIGN]: 'System Design',
  [ROOT_CAUSE_CATEGORIES.CONFIGURATION_ERROR]: 'Configuration Error',
  [ROOT_CAUSE_CATEGORIES.HUMAN_ERROR]: 'Human Error',
  [ROOT_CAUSE_CATEGORIES.PROCESS_FAILURE]: 'Process Failure',
  [ROOT_CAUSE_CATEGORIES.HARDWARE_FAILURE]: 'Hardware Failure',
  [ROOT_CAUSE_CATEGORIES.SOFTWARE_BUG]: 'Software Bug',
  [ROOT_CAUSE_CATEGORIES.CAPACITY_ISSUE]: 'Capacity Issue',
  [ROOT_CAUSE_CATEGORIES.SECURITY_VULNERABILITY]: 'Security Vulnerability',
  [ROOT_CAUSE_CATEGORIES.THIRD_PARTY_DEPENDENCY]: 'Third Party Dependency',
  [ROOT_CAUSE_CATEGORIES.UNKNOWN]: 'Unknown'
};